/* =========================================================
   File: assets/sh-related-products.js
   Website: Capital Floorings
   Purpose: Related products carousel
========================================================= */

(function () {
  'use strict';

  function initRelatedProductsCarousel(section) {
    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var track = section.querySelector('[data-related-track]');
    var prevButton = section.querySelector('[data-related-prev]');
    var nextButton = section.querySelector('[data-related-next]');

    if (!track || !prevButton || !nextButton) {
      return;
    }

    function getScrollAmount() {
      var firstSlide = track.querySelector('.sh-related-products__slide');

      if (!firstSlide) {
        return track.clientWidth;
      }

      var slideStyle = window.getComputedStyle(firstSlide);
      var trackStyle = window.getComputedStyle(track);
      var slideWidth = firstSlide.getBoundingClientRect().width;
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);

      if (Number.isNaN(gap)) {
        gap = 0;
      }

      if (slideStyle && slideWidth) {
        return slideWidth + gap;
      }

      return track.clientWidth;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      prevButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maxScroll;
    }

    prevButton.addEventListener('click', function () {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', function () {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    });

    window.addEventListener('resize', updateButtons);

    updateButtons();
  }

  function initAllRelatedProducts() {
    document.querySelectorAll('[data-sh-related-products]').forEach(function (section) {
      initRelatedProductsCarousel(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllRelatedProducts);
  document.addEventListener('shopify:section:load', initAllRelatedProducts);
})();